const confirmHandler = async (message, element) => {
  // console.log(message, element)
  let result = await sweetAlertConfirmBox(message);

  return new Promise((resolve, reject) => {
    resolve(result)
  })
}

// if (window.Turbo.config) {
//   window.Turbo.config.forms.confirm = confirmHandler
// } else {
//   console.log("Turbo not defined")
// }

export { confirmHandler }
